import React, { useEffect } from "react";
import { useRouter } from "next/router";
import { useSelector } from "react-redux";

export default function BidderDashboardWrapper(props: any) {
  const router = useRouter();
  const userToken = useSelector((state: any) => {
    return state.bankerAuth.accessToken;
  });
  const currentBranch = useSelector((state: any) => {
    return state.bankerAuth.currentBranch;
  });

  useEffect(() => {
    if (!userToken) {
      router.push("/login");
    } else if (userToken && !currentBranch) {
      router.push("/branch");
    }
  }, []);

  return userToken && currentBranch ? props.children : null;
}
